import React from 'react';
import { useNavigate } from 'react-router-dom';
import SideNavbar from '../helpers/SideNavbar';

const IntegrateSocialMedia = () => {
  const navigate = useNavigate();

  const handleLinkedInClick = () => {
    const UserID = localStorage.getItem('UserID');
    const tokenID = localStorage.getItem('Tokenid'); // Get tokenID from URL
    console.log(tokenID)
    if (tokenID) {
      navigate('/home');
    } else {
      // Redirect to LinkedIn login page with guid
      const linkedinAuthorizeUrl = `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/authorize?UserID=${UserID}`;
      window.location.href = linkedinAuthorizeUrl;
    }
  };

  const integrationCards = [
    {
      id: 'linkedin',
      icon: 'fa-linkedin',
      name: 'LinkedIn',
      active: true,
      onClick: handleLinkedInClick,
      bgColor: '#2e3192',
      textColor: '#fff'
    },
    {
      id: 'facebook',
      icon: 'fa-facebook',
      name: 'Facebook',
      active: false,
      bgColor: '#fff',
      textColor: '#2e3192'
    },
    {
      id: 'twitter',
      icon: 'fa-twitter',
      name: 'Twitter',
      active: false,
      bgColor: '#fff',
      textColor: '#2e3192'
    },
    {
      id: 'youtube',
      icon: 'fa-youtube',
      name: 'YouTube',
      active: false,
      bgColor: '#fff',
      textColor: '#2e3192'
    },
    {
      id: 'instagram',
      icon: 'fa-instagram',
      name: 'Instagram',
      active: false,
      bgColor: '#fff',
      textColor: '#2e3192'
    },
    {
      id: 'pinterest',
      icon: 'fa-pinterest',
      name: 'Pinterest',
      active: false,
      bgColor: '#fff',
      textColor: '#2e3192'
    }
  ];

  return (
    <div className="integration-page-container">
      <SideNavbar>
        <div className="card shadow-sm integration-card-wrapper" style={{ 
          border: 'none', 
          backgroundColor: '#fff',
          borderRadius: '12px',
          width: '100%',
          maxWidth: '100%',
          marginLeft: 0,
          marginRight: 0
        }}>
          <div className="card-header integration-card-header" style={{ 
            border: 'none', 
            backgroundColor: '#fff',
            padding: '20px 24px',
            borderRadius: '12px 12px 0 0'
          }}>
            <h5 className="welcome-text" style={{ 
              fontSize: '22px', 
              color: '#2e3192', 
              textAlign: 'left',
              fontWeight: '700',
              margin: '0 0 0 10px'
            }}>
              Integrations
            </h5>
          </div>
          <hr style={{ margin: '0', borderColor: '#eef0f8' }} />

          <div className="integration-content-container">
            <div className="row g-3 g-md-4 integration-row">
              {integrationCards.map((card) => (
                <div 
                  key={card.id}
                  className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                >
                  <div
                    className="card shadow-sm integration-card"
                    style={{
                      border: 'none',
                      backgroundColor: card.bgColor,
                      color: card.textColor,
                      borderRadius: '16px',
                      opacity: card.active ? 1 : 0.5,
                      cursor: card.active ? 'pointer' : 'not-allowed',
                      transition: 'all 0.3s ease',
                      minHeight: '140px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '24px 16px',
                      width: '100%',
                      margin: 0,
                      visibility: 'visible'
                    }}
                    onClick={card.active && card.onClick ? card.onClick : undefined}
                    onMouseEnter={(e) => {
                      if (card.active) {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(46, 49, 146, 0.2)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (card.active) {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                      }
                    }}
                  >
                    <i 
                      className={`fa ${card.icon}`} 
                      style={{ 
                        color: card.textColor, 
                        fontSize: '36px',
                        marginBottom: '10px',
                        display: 'block'
                      }}
                    />
                    <b style={{ 
                      color: card.textColor, 
                      fontSize: '16px',
                      fontWeight: '600',
                      textAlign: 'center',
                      display: 'block',
                      width: '100%'
                    }}>
                      {card.name}
                    </b>
                    {!card.active && (
                      <span style={{
                        fontSize: '12px',
                        color: card.textColor,
                        opacity: 0.7,
                        marginTop: '8px',
                        textAlign: 'center'
                      }}>
                        Coming Soon
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style>{`
          /* Integration Page Specific Styles */
          .integration-page-container {
            width: 100%;
            overflow-x: hidden;
            min-height: 100vh;
          }
          
          .integration-card-wrapper {
            margin-top: 12px;
            margin-left: 0;
            margin-right: 0;
          }
          
          .integration-card-header {
            padding: 16px;
          }
          
          .integration-card-header h5 {
            font-size: 18px;
          }
          
          .integration-content-container {
            padding: 16px 12px;
            width: 100%;
            max-width: 100%;
            margin: 0;
            box-sizing: border-box;
          }
          
          .integration-row {
            margin-left: -8px;
            margin-right: -8px;
            width: 100%;
          }
          
          .integration-row > [class*="col-"] {
            padding-left: 8px;
            padding-right: 8px;
            margin-bottom: 12px;
          }
          
          .integration-card {
            width: 100%;
            min-height: 120px;
            padding: 20px 12px;
            box-sizing: border-box;
          }
          
          .integration-card i {
            font-size: 36px;
            margin-bottom: 10px;
            display: block;
          }
          
          .integration-card b {
            font-size: 16px;
            display: block;
            width: 100%;
          }
          
          /* Small devices (landscape phones, 576px and up) */
          @media (min-width: 576px) {
            .integration-content-container {
              padding: 20px 16px;
            }
            
            .integration-card {
              min-height: 140px;
              padding: 24px 16px;
            }
            
            .integration-card i {
              font-size: 40px;
            }
            
            .integration-card b {
              font-size: 18px;
            }
          }
          
          /* Medium devices (tablets, 768px and up) */
          @media (min-width: 768px) {
            .integration-card-wrapper {
              margin-top: 16px;
            }
            
            .integration-card-header {
              padding: 20px 24px;
            }
            
            .integration-card-header h5 {
              font-size: 22px;
            }
            
            .integration-content-container {
              padding: 24px 20px;
            }
            
            .integration-row > [class*="col-"] {
              margin-bottom: 16px;
            }
            
            .integration-card {
              min-height: 150px;
              padding: 28px 20px;
            }
            
            .integration-card i {
              font-size: 44px;
            }
            
            .integration-card b {
              font-size: 20px;
            }
          }
          
          /* Large devices (desktops, 992px and up) */
          @media (min-width: 992px) {
            .integration-content-container {
              padding: 24px;
            }
            
            .integration-card {
              min-height: 160px;
              padding: 32px 24px;
            }
            
            .integration-card i {
              font-size: 48px;
            }
          }
          
          /* Ensure cards don't overflow on mobile */
          @media (max-width: 575px) {
            .integration-page-container {
              overflow-x: hidden;
              width: 100%;
            }
            
            .integration-card {
              padding: 18px 10px;
              min-height: 110px;
              width: 100%;
              box-sizing: border-box;
            }
            
            .integration-row {
              margin-left: -4px;
              margin-right: -4px;
              width: calc(100% + 8px);
            }
            
            .integration-row > [class*="col-"] {
              padding-left: 4px;
              padding-right: 4px;
              width: 100%;
              flex: 0 0 100%;
              max-width: 100%;
            }
            
            .integration-card i {
              font-size: 32px;
              margin-bottom: 8px;
            }
            
            .integration-card b {
              font-size: 15px;
            }
            
            .integration-content-container {
              padding: 12px 8px;
            }
            
            .integration-card-header {
              padding: 14px 16px;
            }
            
            .integration-card-header h5 {
              font-size: 18px;
            }
          }
          
          /* Extra small devices */
          @media (max-width: 375px) {
            .integration-card {
              padding: 16px 8px;
              min-height: 100px;
            }
            
            .integration-card i {
              font-size: 28px;
            }
            
            .integration-card b {
              font-size: 14px;
            }
            
            .integration-content-container {
              padding: 10px 6px;
            }
            
            .integration-card-header {
              padding: 12px;
            }
            
            .integration-card-header h5 {
              font-size: 16px;
            }
          }
        `}</style>
      </SideNavbar>
    </div>
  );
};

export default IntegrateSocialMedia;

